import { render, staticRenderFns } from "./suggestionsListCollaborativeFilteringAdder.vue.html?vue&type=template&id=6715bbb5&"
import script from "./suggestionsListCollaborativeFilteringAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListCollaborativeFilteringAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports